import UserSettingsFtue from "../../client-data/user/ftue"
import ModalUpgrade from "./upgrade/upgrade-modal"
import ModalHighPerformance from "./high-performance/high-performance"

// @ts-ignore
import ModalSkipTour from "./tour-skip/tour-skip-modal"
import ModalQuickSearch from "../../../app/search/quick/modal";
import {Feature} from "../../gd/access-control/feature-access/const";

// @ts-ignore
const modalQuickTour = () => import(/* webpackChunkName: "quick-tour" */ '../../misc/tour/modal/modal-quick-tour');
// @ts-ignore
const modalRecurrence = () => import(/* webpackChunkName: "recurrence" */ '../recurrence/recurrence-modal');

export default class OtherModalsManager {

    constructor() {}

    // used in task view to view original source email email from task or message from reply
    viewOriginalEmail(taskId:ID, messageId?:ID) {
        gd.modal.showFullHeight({
            className: 'modal-original-email',
            header: {
                // title: "Original Email"
            },
            component: require('./original-email/original-email'),
            params: {
                taskId: taskId,
                messageId: messageId
            }
        });
    }

    notification(message:any, btnLabel?:string) {
        gd.modal.showConfirm({
            className: 'modal-notification',
            component: require('../notification-message/notification-message.jsx'),
            params: {
                onSubmit(values:any) {
                    gd.modal.hide();
                },
                btnLabel: btnLabel,
                message: message
            }
        });
    }


    rateGoodDayExperience(rating:any=false, callback?:callback) {

        gd.modal.showFullHeight({
            className: 'modal-rate-experience',
            header: {
                title: "Hello " +gd.session.me.name + "! Please rate your GoodDay experience"
            },
            component: require('../rate-experience/rate-experience.jsx'),
            params: {
                initRating  : rating,
                callback    : callback // on submit
            }
        });
    }

    upgrade(feature: Feature | boolean = false) {
        gd.modal.showGeneric({
            // component: require('./other/upgrade/upgrade-modal.tsx'),
            component: ModalUpgrade,
            className: '',
            params: {
                feature         : feature,
                // organizationId: gd.companyId
            }
        });
    }

    upgradeToPro(feature:any=null) {
        gd.modal.showGeneric({
            component: ModalUpgrade,
            className: 'modal-upgrade',
            params: {
                feature         : feature,
            }
        });
    }

    showMagicSearch() {
        gd.modal.showV4({
            className: 'modal-magic-search',
            component: ModalQuickSearch,
        })
    }

    addUsers(projectId:ID|null, users:any, multiselect = false, accessLevels: number[] | null, callback:callback) {
        gd.modal.showV4({
            className: 'modal-add-user',
            component: require('../add-user/add-user.jsx'),
            params: {
                onSubmit: (userId:ID)=>{
                    if (callback) callback(userId);
                    gd.modal.hide();
                },
                multiselect : multiselect,
                companyId   : gd.companyId,
                projectId   : projectId,
                users       : users,
                mode        : 'common',
                accessLevels: accessLevels
            }
        });
    }

    quickTour(quickTourId:any) {
        gd.modal.loadAndShow(modalQuickTour, false, {
            className: 'modal-take-tour',
            modalType: 'v4',
            toggleCallback: (isOpen:boolean) => {
                // always mark as read when read
                if (!isOpen) {
                    UserSettingsFtue.markTourWatched(quickTourId);
                }
            },
            params: {
                quickTourId: quickTourId,
                onFinishCallback: ()=>{
                    gd.modal.hide();
                }
            }
        });
    }

    skipTour(config?:any) {
        gd.modal.showV4({
            className: 'modal-skip-tour',
            component: ModalSkipTour,
            params: {
                config,
                callback: ()=>{
                    gd.modal.hide();
                }
            }
        });
    }

    // create recurrence
    recurrence(type:any, itemId:any, recurrenceId:any=null) {
        gd.modal.loadAndShow(modalRecurrence, false, {
            className: 'modal-recurrence',
            modalType: 'v4',
            params: {
                type            : type,
                id              : itemId,
                recurrenceId    : recurrenceId,
                onFinishCallback: ()=>{
                    gd.modal.hide();
                }
            }
        });
    }

    highPerformanceMode() {
        gd.modal.showGeneric({
            component: ModalHighPerformance,
            className: 'modal-high-performance',
        })
    }
}

